/**************************************************************************
Name:         main.js
Description:  Site scripting.
Date Created: 09/27/2012 by Kyle Brickman
Modified:     02/16/2015 by Roxanne Martinez - added Redactor
**************************************************************************/

	/* Redactor plugin storage */
	if( !RedactorPlugins )
		var RedactorPlugins = {};

/* Site navigation */
loadEvents.push( function( )
{
	var nav = {
		inputClick   : 'click',
		inputUp      : window.PointerEvent ? 'pointerup'    : window.MSPointerEvent ? 'MSPointerUp'    : 'mouseup touchend touchcancel',
		inputEnter   : window.PointerEvent ? 'pointerenter' : window.MSPointerEvent ? 'MSPointerEnter' : 'mouseover touchstart',
		inputMove    : window.PointerEvent ? 'pointermove'  : window.MSPointerEvent ? 'MSPointerMove'  : 'mousemove touchmove',

		isStockAndroid : null != navigator.userAgent.toLowerCase( ).match( /android/ ) &&
		                 null == navigator.userAgent.toLowerCase( ).match( /chrome/  ) &&
		                 null == navigator.userAgent.toLowerCase( ).match( /firefox/ ) &&
		                 null == navigator.userAgent.toLowerCase( ).match( /opera/   ),

		calculate : function( )
		{
			/* MobileNav */
			$( '.nav-list-container' ).css( 'max-height', $( window ).height( ) + 'px' );

			if( 'none' == $( '.l-nav'  ).css( 'display' )) nav.hideMobileNav(  );
		},

		showMobileNav : function( evt )
		{
			evt.preventDefault( );

			if( !$( '.l-nav' ).hasClass( 'is-open' ))
			{
				$( '.l-nav' ).addClass( 'is-open' );
				$('html').css("overflow", "hidden");

				$( 'div.curtain' ).css('filter','0').fadeIn().css('filter',"progid:DXImageTransform.Microsoft.gradient( startColorstr='#80000000', endColorstr='#80000000',GradientType=0 )");
			}
			else
				nav.hideMobileNav( );
		},

		hideMobileNav : function( evt )
		{
			if( evt && $( '.l-nav-list *, .nav-menu-container *' ).filter( evt.target ).length )
				return;

			$( '.l-nav' ).removeClass( 'is-open' );
			$('html').css("overflow-y", "auto");

			$('<style></style>').appendTo($(document.body)).remove();

			$( 'div.curtain' ).css('filter','0').fadeOut().css('filter',"progid:DXImageTransform.Microsoft.gradient( startColorstr='#80000000', endColorstr='#80000000',GradientType=0 )");
		},

		init : function( )
		{
			var self = this;

			self.calculate( );

			$( window ).on( 'resize orientationchange', self.calculate );

			$( '.nav-menu-container' ).on( self.inputClick, self.showMobileNav );
			$( '.curtain' ).on( self.inputUp, self.hideMobileNav );
		}
	}
	nav.init( );
});

function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};


/********************************************************************************************
Show/hide header on scroll
From: https://medium.com/@mariusc23/hide-header-on-scroll-down-show-on-scroll-up-67bbaae9a78c
********************************************************************************************/
var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('header').outerHeight();

$(window).scroll(function(event){
    didScroll = true;
});

setInterval(function() {
    if (didScroll) {
        hasScrolled();
        didScroll = false;
    }
}, 100);

function hasScrolled() {
    var st = $(this).scrollTop();

    // Make sure they scroll more than delta
    if(Math.abs(lastScrollTop - st) <= delta)
        return;

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight){
        // Scroll Down
        $('header').removeClass('is-down').addClass('is-up');
    } else {
        // Scroll Up
        if(st + $(window).height() < $(document).height()) {
            $('header').removeClass('is-up').addClass('is-down');
        }
    }

    lastScrollTop = st;
}

// (function(url) {
//   // Create a new `Image` instance
//   var image = new Image();

//   image.onload = function() {
//     // Inside here we already have the dimensions of the loaded image
//     var style = [
//       // Hacky way of forcing image's viewport using `font-size` and `line-height`
//       'font-size: 1px;',
//       'line-height: 75px;',

//       // Hacky way of forcing a middle/center anchor point for the image
//       'padding: ' + 75 * .5 + 'px ' + 220 * .5 + 'px;',

//       // Set image dimensions
//       'background-size: 220px 75px;',

//       // Set image URL
//       'background: url('+ url +');'
//      ].join(' ');

//      // notice the space after %c
//      console.log('%c ', style);
//   };

//   // Actually loads the image
//   image.src = url;
// })('https://www.avibeweb.com/images/logo-email.png');


/* IE 10 fix */
if ( navigator.appVersion.indexOf('MSIE 10') != -1 )
{
	$( 'html' ).addClass( 'is-ie' );
	$( 'html' ).addClass( 'is-ie10' );
	$( 'html' ).addClass( 'lt-ie11' );
}

/* IE 11 fix */
if ( navigator.appVersion.indexOf('Trident') != -1 && navigator.appVersion.indexOf('rv:11') != -1 )
{
	$( 'html' ).addClass( 'is-ie' );

	if ( navigator.appVersion.indexOf('rv:11') != -1 )
		$( 'html' ).addClass( 'is-ie11' );
}

/* Legacy Android fix */
if( /android/i.test( navigator.userAgent ))
{
	$( 'html' ).addClass( 'is-android' );

	if( !/chrome/i.test(  navigator.userAgent ) &&
	    !/firefox/i.test( navigator.userAgent ) &&
	    !/opera/i.test(   navigator.userAgent ))
		$( 'html' ).addClass( 'is-legacy-android' );
}

if( /ip(hone|od|ad)/i.test( navigator.userAgent ))
{
	$( 'html' ).addClass( 'is-ios' );

	if( 6 >= parseInt( navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/ )[1] ))
		$( 'html' ).addClass( 'is-legacy-ios' );
}

if(/Safari/i.test(navigator.userAgent))
{
	$('html').addClass('is-ios');
}

 /* Windows touch device support */
/* Support for full site's top navigation on touch devices */
if( navigator.msMaxTouchPoints > 0 || navigator.maxTouchPoints > 0 ){ $( 'html' ).addClass( 'touch' ); }

var query = "(-webkit-min-device-pixel-ratio: 2), (min-device-pixel-ratio: 2), (min-resolution: 192dpi)";
if (matchMedia(query).matches) {
	$('html').addClass('is-retina');
}

/* Redactor plugin storage
if( !RedactorPlugins )
	var RedactorPlugins = {}; */

/* Displays site navigation dropdown if wireless */
loadEvents[loadEvents.length] = function( ){
	$( 'nav ul.global a.menu, nav a.menu' ).on( 'click', function( evt ){
		evt.preventDefault( );

		if( $( 'nav ul.sections' ).hasClass( 'hiddenNav' ) ){
			$( 'nav ul.sections' ).removeClass( 'hiddenNav' );
			$( 'nav ul.sections' ).parent().addClass( 'visibleOverflow' );
		}else{
			$( 'nav ul.sections' ).addClass( 'hiddenNav' );
			$( 'nav ul.sections' ).parent().removeClass( 'visibleOverflow' );
		}
	});
	$( window ).on( 'resize', function( evt ){
		$( 'nav ul.sections' ).addClass( 'hiddenNav' );
	});
}

/* Resizes fieldsets to maximum row height */
var resizeFieldsets = function( )
{
	var fieldsets = $( 'fieldset' ).not( '.controls' );
	var currentTop    = 0;
	var currentHeight = 0;

	fieldsets.height( 'auto' );

	for( var i = 0; i < fieldsets.length; i++ )
	{
		var thisTop    = $( fieldsets[i] ).offset( ).top;
		var thisHeight = $( fieldsets[i] ).height( );

		if( thisTop == currentTop )
		{
			if( thisHeight > currentHeight )
			{
				currentHeight = thisHeight;

				for( var j = i; j >= 0; j-- )
				{
					if( $( fieldsets[j] ).offset( ).top == thisTop )
						$( fieldsets[j] ).height( currentHeight );
					else
						j = 0;
				}
			}
			if( thisHeight < currentHeight )
			{
				$( fieldsets[i] ).height( currentHeight );
			}
		}
		else
		{
			currentTop    = thisTop;
			currentHeight = thisHeight;
		}
	}
}

loadEvents[loadEvents.length] = function( ){
	if( $( 'fieldset' ).not( '.controls' ).length )
	{
		$( window ).on( 'orientationchange resize', resizeFieldsets );
		resizeFieldsets( );
	}
}

/* Supports tree-like tables */
var toggleChildRows = function( evt )
{
	evt.preventDefault( );

	var parentA     = $( this );
	var parentTR    = parentA.parent( ).parent( );
	var parentTBODY = parentTR.parent( );
	var parentTABLE = parentTBODY.parent( );
	var parentID    = parentTR.attr( 'data-id' );
	var parentTABLENUM = -1;

	if( parentTABLE.parents( '.pinned' ).length ){
		var parentTABLENUM = parentTABLE.parents( '.pinned' ).attr( 'tablenum' );
		if( typeof parentTABLENUM != 'undefined' && parentTABLENUM !== false ){
			parentTABLE = $( 'div.pinned[tablenum="' + parentTABLENUM + '"] table,div.scrollable[tablenum="' + parentTABLENUM + '"] table' );
			parentTBODY = $( 'div.pinned[tablenum="' + parentTABLENUM + '"] table tbody,div.scrollable[tablenum="' + parentTABLENUM + '"] table tbody' );
		}
	}

	if( 'Collapse' == parentA.attr( 'title' ))
	{
		var children = $( 'tr', parentTBODY ).filter( '[data-parent^="' + parentID + '"]' );

		children.hide( );

		$( 'a.collapse', children ).removeClass( 'collapse' ).addClass( 'expand' ).attr( 'title', 'Expand' ).text( 'Expand' );
		parentA.removeClass( 'collapse' ).addClass( 'expand' ).attr( 'title', 'Expand' ).text( 'Expand' );
	}
	else
	{
		var children = $( 'tr', parentTBODY ).filter( '[data-parent="' + parentID + '"]' );

		children.show( );
		parentA.removeClass( 'expand' ).addClass( 'collapse' ).attr( 'title', 'Collapse' ).text( 'Collapse' );
	}

	// Candy striping support
	if( !parentTABLE.hasClass( 'nostripe' ))
	{
		$( 'tr' ).removeClass( );

		var stripeIndex = 0;
		if( parentTABLE.parents( '.pinned' ).length ){
			$( 'tr', $( 'div.pinned[tablenum="' + parentTABLENUM + '"] table tbody' ) ).not( ':hidden' ).each( function( index ){
				stripeIndex += 1;
				$( this ).addClass( 0 == stripeIndex % 2 ? 'evenChild' : 'oddChild' );
			});
			stripeIndex = 0;
			$( 'tr', $( 'div.scrollable[tablenum="' + parentTABLENUM + '"] table tbody' ) ).not( ':hidden' ).each( function( index ){
				stripeIndex += 1;
				$( this ).addClass( 0 == stripeIndex % 2 ? 'evenChild' : 'oddChild' );
			});
		}else{
			$( 'tr', parentTBODY ).not( ':hidden' ).each( function( index ){
				stripeIndex += 1;
				$( this ).addClass( 0 == stripeIndex % 2 ? 'evenChild' : 'oddChild' );
			});
		}
	}

	writeTreeSessionStorage( parentTABLE );
}

var writeTreeSessionStorage = function( parentTABLE )
{
	// HTML5 session storage
	if( 'undefined' !== typeof( Storage ))
	{
		var path       = window.location.pathname.replace( /\//g, '_' );
		var dataID     = [];
		var dataStatus = [];


		sessionStorage[ 'tree' + path ] = '';

		$( 'tr[data-id]', parentTABLE ).each( function( index ){
			dataID[        dataID.length] = $( this ).attr( 'data-id' );
			dataStatus[dataStatus.length] = $( 'a', $( this )).first( ).hasClass( 'collapse' );
		})

		dataID     =     dataID.join( ',' );
		dataStatus = dataStatus.join( ',' );

		sessionStorage[ 'tree' + path ] +=     dataID + '|';
		sessionStorage[ 'tree' + path ] += dataStatus + '|';
	}
};

var readTreeSessionStorage = function( parentTABLE )
{
	var path = window.location.pathname.replace( /\//g, '_' );

	// HTML5 session storage
	if( 'undefined' !== typeof( Storage ) && sessionStorage[ 'tree' + path ])
	{
		var dataID     = sessionStorage[ 'tree' + path ].split( '|' )[0].split( ',' );
		var dataStatus = sessionStorage[ 'tree' + path ].split( '|' )[1].split( ',' );

		$( 'tr[data-id]', parentTABLE ).hide( );
		$( 'tr[data-id] a.inline.collapse' ).text( 'Expand' ).attr( 'title', 'Expand' ).removeClass( 'collapse' ).addClass( 'expand' );
		$( 'tr[data-id]', parentTABLE ).first( ).show( );

		for( var i = 0; i < dataID.length; i++ )
		{
			if( 'true' === dataStatus[i] )
				$( 'tr[data-id="' + dataID[i] + '"] a.inline.expand' ).trigger( 'click' );
		}
	}
	else
	{
		$( 'a.inline.collapse', parentTABLE ).first( ).trigger( 'click' ).trigger( 'click' );
	}
}

/* Displays a confirmation banner */
var displayConfirmationBanner = function( evt )
{
	evt.preventDefault( );

	var target    = $( evt.target   );
	var banner    = $( '<p />'      );
	var yesButton = $( '<input />'  );
	var  noButton = $( '<input />'  );
	var after     = $( 'article h2' );

	if( !after.length )
		after = $( 'article h1' );

	after = after.first( );

	banner.addClass( 'banner'  );
	banner.addClass( 'example' );
	banner.text( target.attr( 'data-message' ) ? target.attr( 'data-message' ) : target.attr( 'title' ) ? target.attr( 'title' ) : target.attr( 'href' ));

	yesButton.val( 'Yes' ); yesButton.attr( 'type', 'button' );
	 noButton.val(  'No' );  noButton.attr( 'type', 'button' );

	yesButton.on( 'click', function( evt ){
		if( undefined != target.attr( 'data-submit' ) && 'true' == target.attr( 'data-submit' ))
			target.closest( 'form' ).get( 0 ).submit( )
		else
			window.location = target.attr( 'href' );

		closeAlertBanner( evt );
	});
	noButton.on( 'click', closeAlertBanner );

	 noButton.prependTo( banner );
	yesButton.prependTo( banner );

	banner.insertAfter( after );

	banner.animate({ top: 0, marginBottom: 0 }, 400 );

	$("html, body").animate({ scrollTop: 0 }, 100);
};

/* Displays an alert banner */
var displaySuccessBanner = function( msg ){ displayAlertBanner( msg, 'success' ); };
var displayWarningBanner = function( msg ){ displayAlertBanner( msg, 'warning' ); };
var displayFailureBanner = function( msg ){ displayAlertBanner( msg, 'failure' ); };
var displayExampleBanner = function( msg ){ displayAlertBanner( msg, 'example' ); };

var displayAlertBanner = function( msg, type )
{
	var banner = $( '<p />' );
	var close  = $( '<a />' );
	var after  = $( 'article h2' );

	if( !after.length )
		after = $( 'article h1' );

	after = after.first( );

	if( undefined == type || ( 'example' != type && 'success' != type && 'warning' != type && 'failure' != type ))
		type = 'example';

	banner.addClass( 'banner' );
	banner.addClass( type     );
	banner.html( msg );

	close.addClass( 'close' + type );
	close.addClass( 'icon'  );
	close.text(     'Close' );
	close.attr( 'href',  '#'     );
	close.attr( 'title', 'Close' );
	close.on( 'click', closeAlertBanner );

	close.prependTo( banner );

	banner.insertAfter( after );

	banner.animate({ top: 0, marginBottom: 10 }, 400 );

	$("html, body").animate({ scrollTop: 0 }, 100);
};

/* Closes an alert or confirmation banner */
var closeAlertBanner = function( evt )
{
	evt.preventDefault( );

	var target = $( evt.target );
	var banner = target.parent( );

	banner.animate({ top: -150, marginBottom: -42 }, 400, function( ){ banner.remove( ); });
}

/* Template support - DO NOT REMOVE */
window.jQuery || document.write( '<script src = "/scripts/jquery-1.10.1.min.js"><\/script>' );

for( var i = 0; i < loadScripts.length; i++ )
	document.write( '<script src = "' + loadScripts[i] + '"><\/script>' );

// $( window ).on("load", function( ){
// 	for( var i = 0; i < loadEvents.length; i++ )
// 		loadEvents[i]( );
// });

console.log("%cSite by A-VIBE Web Development", "color: #448ba7; font-family: brandon-grotesque,Helvetica Neue,Arial; font-size: 16px;");